<template>
    <shield-modal
        :id="'escrow-information-modal'"
        :size="'lg'"
        @handleCancel="cancel"
        @handleSubmit="save"
        :enableSubmit="isValid"
        :hideHeaderClose="false">
        <template #title>
            New Home Sale Legal Protection Reservation&trade;
        </template>
        <template #default>
            <page-loader :loading="loading" />
            <b-row>
                <b-col cols="12" class="d-flex justify-content-center">
                    <p>Your seller has reserved Home Sale Legal Protection&trade; for this property:</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="d-flex justify-content-center">
                    <p class="text-center">
                        <b>{{ sellerName }}</b><br/>
                        <b>{{ streetAddress }}</b><br/>
                        <b>{{ cityState }}</b>
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="d-flex justify-content-center">
                    <p>Please provide escrow informtion so their payment can be processed at closing.</p>
                </b-col>
            </b-row>
            <template v-if="!showAddNew">
                <b-row>
                    <b-col cols="12" md="5">
                        <p><b>Select from your saved escrow officers or</b></p>

                    </b-col>
                    <b-col cols="7" class="d-flex justify-content-start">
                        <button class="white-button btn-body" @click="handleShowNewEscrowOfficer">
                            Add New Escrow Officer
                        </button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group class="escrow-officer-selection-form"
                            description="Select which escrow officer will manage the closing or add their information."
                            label="Escrow Officer" 
                            label-for="escrow-dropdown"
                            >
                            <b-form-select id="escrow-dropdown" v-model="selectedOfficer" :options="contacts"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template v-else>
                <b-form-group
                    class="escrow-officer-creation-form"
                    label="Escrow Officer Name"
                    label-for="escrow-officer-name"
                    :state="errors.fullName">
                    <b-form-input id="escrow-officer-name" v-model="escrow.fullName" :state="errors.fullName" @input="handleInputChange($event,'fullName')"></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback :state="errors.fullName">
                    {{messages.fullName}}
                </b-form-invalid-feedback>
                <b-form-group
                    class="escrow-officer-creation-form"
                    label="Escrow Officer Email Address"
                    label-for="escrow-officer-email-address"
                    :state="errors.email">
                    <b-form-input id="escrow-officer-email-address" v-model="escrow.email" :state="errors.email" @input="handleInputChange($event,'email')"></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback :state="errors.email">
                    {{ messages.email }}
                </b-form-invalid-feedback>
                <b-form-group
                    class="escrow-officer-creation-form"
                    label="Title Company Name"
                    label-for="title-company-name"
                    :state="errors.titleCompany">
                    <b-form-input id="title-company-name" v-model="escrow.titleCompany" :state="errors.titleCompany" @input="handleInputChange($event,'titleCompany')"></b-form-input>
                </b-form-group>
            </template>
            <b-row>
                <b-col cols="12">
                    <b-form-group 
                        class="escrow-officer-selection-form" 
                        label="Closing Date"
                        label-for="closing-date-escrow-selection-form"
                        >
                        <b-form-datepicker 
                            id="closing-date-escrow-selection-form" 
                            v-model="escrow.closingDate"
                            :min="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())"></b-form-datepicker>
                        
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-if="showAddNew">
                <div class="save-created-escrow-officer">
                    <b-form-checkbox
                        id="save-created-escrow-officer-checkbox" 
                        v-model="saveTitle"
                        value=true
                        unchecked-value=false
                    >
                        Save information to preferred title companies.
                    </b-form-checkbox>
                </div>
            </template>
        </template>
        <template #submit-btn>Confirm</template>
        <template #cancel-btn>Remind me later</template>
    </shield-modal>
</template>
<script>
import './EscrowInformationModal.scss';
import ShieldModal from '@components/modals/ShieldModal/ShieldModal.vue';
import {primarySellerName, propertyStreetAddress, propertyCity, propertyStateName} from '@helpers/order';
import OrderAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource';
import EscrowOfficerAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/EscrowOfficerAppResource';
import ContactAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/ContactAppResource';
import { AppResourceSearch, ApiFilter } from '@sellers-shield-home-protection/ss-core-js';
import UserMixin from '@mixins/UserMixin';
import FlatPickr from 'vue-flatpickr-component';
import { isValidEmail } from '@helpers/email';
import dayjs from 'dayjs';
import {getUTCDate} from '@helpers/dates';
import { ESCROW_OFFICER } from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuContactTypeAppResource'
import {TRANSACTION_COORDINATOR} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuAccountTypeAppResource';
export default {
    name: 'EscrowInformationModal',
    components:{
        ShieldModal,
        FlatPickr
    },
    mixins:[
        UserMixin
    ],
    props:{
        orderAppResource:{
            type: OrderAppResource
        },        
    },
    data:()=>({
        showAddNewEscrowOfficer: false,
        contactAppResourceSearch: new AppResourceSearch('contact'),
        options: [],
        saveTitle: false,
        escrow:{
            fullName: null,
            email: null,
            titleCompany: null,
            closingDate: null
        },
        errors:{
            fullName: null,
            email: null,
            titleCompany: null,
            closingDate: null
        },
        messages:{
            fullName: null,
            email: null,
            titleCompany: null,
            closingDate: null
        },
        selectedOfficer: null,
        dateConfig: {
            clickOpens:true,
            wrap: false,
            allowInput: false,
            altFormat: 'M j, Y',
            dateFormat: 'Y-m-d',
            minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            disableMobile: true
        },
        loading:false
    }),
    watch:{
        orderAppResource:{
            immediate: true,
            async handler(newVal){
                if(!newVal){
                    return;
                }
                if(newVal.escrowOfficer){
                    this.escrow.fullName = newVal?.escrowOfficer?.get('fullName');
                    this.escrow.email = newVal?.escrowOfficer?.get('email');

                }else{
                    this.escrow.fullName = null;
                    this.escrow.email = null;
                }
                // this.escrow.titleCompany = newVal?.titleCompanyName;
                this.escrow.titleCompany = newVal?.get('titleCompanyName');
                // this.escrow.closingDate = new Date(newVal?.closingDate ?? this.dateConfig.minDate);
                this.escrow.closingDate = newVal?.get('closingDate') ? new Date(newVal?.get('closingDate')) : null;
                this.showAddNewEscrowOfficer = this.escrowOfficer && 
                    this.escrow.fullName &&
                    this.escrow.email;
                this.selectedOfficer = null;
            }
        }
    },
    methods:{
        async save(){
            this.loading = true;
            let invitationMeta = this.orderAppResource.invitation.meta;
            if(this.showAddNewEscrowOfficer){
                this.escrowOfficer.setAttribute('fullName', this.escrow.fullName);
                this.escrowOfficer.setAttribute('email', this.escrow.email);
                this.orderAppResource.setAttribute('titleCompanyName', this.escrow.titleCompany);
                invitationMeta = {
                    ...invitationMeta,
                    payAtCloseInputs: {
                        escrowOfficerName: this.escrow.fullName,
                        escrowOfficerEmail: this.escrow.email,
                        titleCompany: this.escrow.titleCompany,
                        closingDate: this.escrow.closingDate
                    }
                }
            }else{
                this.escrowOfficer.setAttribute('fullName', this.selectedOfficer.get('fullName'));
                this.escrowOfficer.setAttribute('email', this.selectedOfficer.get('email'));
                this.orderAppResource.setAttribute('titleCompanyName', this.selectedOfficer.get('companyName'));
                invitationMeta = {
                    ...invitationMeta,
                    payAtCloseInputs: {
                        escrowOfficerName: this.selectedOfficer.fullName,
                        escrowOfficerEmail: this.selectedOfficer.email,
                        titleCompany: this.selectedOfficer.get('companyName') ?? '',
                        closingDate: this.escrow.closingDate
                    }
                }                
            }
            this.escrowOfficer.setAttribute('orderUuid', this.orderAppResource.uuid);
            if(this.escrow.closingDate){
                this.escrow.closingDate = getUTCDate(this.escrow.closingDate)
            }
            this.orderAppResource.setAttribute('closingDate', this.escrow.closingDate);
            this.orderAppResource.invitation.setAttribute('meta', invitationMeta);
            await this.orderAppResource.invitation.save();
            await this.escrowOfficer.save();
            await this.orderAppResource.save();

            if(this.saveTitle){
                let contact = new ContactAppResource({});
                contact.setAttribute('contactTypeId', ESCROW_OFFICER);
                contact.setAttribute('fullName', this.escrow.fullName);
                contact.setAttribute('email', this.escrow.email);
                contact.setAttribute('companyName', this.escrow.titleCompany);
                // contact.setAttribute('userUuid', this.me.uuid);
                console.log("check my guess", this.orderAppResource.agent?.uuid)
                contact.setAttribute('userUuid', this.orderAppResource.agent?.uuid);
                await contact.save();
            }
            this.loading = false;
            this.$emit('refresh');
            this.$bvModal.hide('escrow-information-modal');
        },
        cancel(){
            this.showAddNewEscrowOfficer = false;
            this.$bvModal.hide('escrow-information-modal');
        },
        async loadContacts(){
            const searchData = {
                filter: new ApiFilter({
                    params: {
                        userUuid: this.me?.accountTypeId === TRANSACTION_COORDINATOR ? this.orderAppResource?.agentUuid : this.me.uuid,
                        // contactTypeId: ESCROW_OFFICER
                    },
                }),
            };
            await this.contactAppResourceSearch.setSearchData(searchData);
            // setupEngine();
            await this.contactAppResourceSearch.search();
            this.options = this.contactAppResourceSearch.appResourceCollection.toArray();
        },
        async handleShowNewEscrowOfficer(){
            this.showAddNewEscrowOfficer = true;
        },
        handleInputChange(value, prop){
            this.escrow[prop] = value;
            this.validate();
        },
        validate(){
            
            if(this.showAddNewEscrowOfficer){
                this.errors.fullName = null;
                this.errors.email = null;
                this.messages.email = null;
                this.messages.fullName = null;
                if(!this.escrow.fullName){
                    this.errors.fullName = false;
                    this.messages.fullName = 'This field is required.'
                }

                if(!isValidEmail(this.escrow.email)){
                    this.errors.email = false;
                    this.messages.email = 'Invalid Email Address.'
                }
            }
        },
    },
    computed:{
        isValid(){
            return Boolean(this.showAddNewEscrowOfficer ? 
                this.escrowOfficer && 
                this.escrow.fullName &&
                this.escrow.email :
                !!this.selectedOfficer);
        },
        sellerName(){
            return this.orderAppResource ? primarySellerName(this.orderAppResource) : '';
        },
        streetAddress(){
            return this.orderAppResource ? propertyStreetAddress(this.orderAppResource) : '';
        },
        cityState(){
            return this.orderAppResource ? propertyCity(this.orderAppResource) + ', ' + propertyStateName(this.orderAppResource) : '';
        },
        contacts(){
            return this.options.map(x => { 
                return {
                    value: x,
                    text: x.fullName
                }
            });
        },
        showAddNew(){
            return this.showAddNewEscrowOfficer;
        },
        escrowOfficer(){
            return this.orderAppResource?.escrowOfficer ?? new EscrowOfficerAppResource({
                orderUuid: this.orderAppResource.uuid
            });;
        }
    },
    async created(){
        await this.loadContacts();

    }
}
</script>
